export default __webpack_public_path__ + "static/media/step1.79ac9f2b.png";